/* eslint-disable react/no-array-index-key */
import { useState } from "react";

import { useUIStateStore } from "@/store/uiStateStore";

function CompontentTabs({ tabs, objects }) {
  const [currentTab, setCurrentTab] = useState(0);
  const isTunecore = useUIStateStore(state => state.isTunecore);

  return (
    <>
      <div className="flex flex-wrap">
        {tabs.map((t, i) => (
          <button
            type="button"
            onClick={() => setCurrentTab(i)}
            key={`tab${i}`}
            className={`w-full focus:outline-none lg:w-1/4 ${i === (tabs.length - 1) ? "pr-0" : "pr-1"}`}
          >
            <>
              {!isTunecore ? (
                <div
                  className={`w-full rounded-t-xl ${
                    currentTab === i
                      ? `bg-linear-to-b from-layer-disabled to-white tab-shadow z-10`
                      : "bg-layer-disabled"
                  }`}
                  style={{ height: currentTab === i ? "340px" : "320px", marginTop: currentTab === i ? "0px" : "20px" }}
                >
                  {t}
                </div>
              ) : (
                <div
                  className={`w-full rounded-t-xl ${
                    currentTab === i
                      ? `bg-linear-to-t from-layer-inverse to-layer-raised tab-shadow z-10`
                      : "bg-canvas-inverse"
                  }`}
                  style={{ height: currentTab === i ? "340px" : "320px", marginTop: currentTab === i ? "0px" : "20px" }}
                >
                  {t}
                </div>
              )}
            </>
          </button>
        ))}
      </div>
      {objects.map((o, i) => (
        <div
          style={{ display: i === currentTab ? "block" : "none" }}
          key={`object${i}`}
          className={`z-20 ${isTunecore ? "bg-layer-inverse" : "bg-white"} w-full relative p-0 pt-8`}
        >
          {o}
        </div>
      ))}
    </>
  );
}
export default CompontentTabs;
